import React from "react";
import FinalCtaPanel from "../../components/FinalCtaPanel";
import { finalCtaContent } from "./homeContent";

const HomeFinalCta = () => (
  <FinalCtaPanel
    id="home-final-cta-heading"
    title={finalCtaContent.title}
    paragraph={finalCtaContent.paragraph}
    cta={finalCtaContent.cta}
    image="/assets/cta/certification-journey.webp"
  />
);

export default HomeFinalCta;
